import React from 'react';
import {
  InputLabel,
  TextField,
  TextFieldProps,
  Typography,
} from '@mui/material';
import {
  Control,
  Controller,
  FieldError,
  RegisterOptions,
} from 'react-hook-form';

export type TFProps = TextFieldProps & {
  readOnly?: boolean;
  control?: Control;
  rules?: RegisterOptions;
};

export const RootineTextField = (props: TFProps): JSX.Element => {
  const getInputProps = () => {
    if (props.readOnly) {
      return {
        disableUnderline: props.readOnly,
        style: {
          color: '#858585',
        },
      };
    } else {
      return {
        style: {
          maxHeight: 45,
        },
      };
    }
  };

  const renderTextField = (
    onChange: any,
    value: any,
    error: FieldError | undefined
  ) => {
    return (
      <TextField
        {...props}
        onChange={onChange}
        value={value}
        error={!!error}
        helperText={error ? error.message : null}
        variant={props.readOnly ? 'standard' : 'filled'}
        InputLabelProps={{ style: { display: 'none' } }}
        InputProps={getInputProps()}
        inputProps={{
          style: {
            border: 0,
            fontSize: 24,
            fontFamily: 'nb_international_prolight',
          },
          'data-recurly': props.name,
        }}
      />
    );
  };

  return (
    <>
      <InputLabel
        htmlFor={props.id}
        sx={{ overflowWrap: 'break-word', whiteSpace: 'normal' }}
      >
        <Typography
          variant="bold"
          color="text.secondary"
          sx={{
            fontSize: 16,
            textDecoration: 'underline',
            textDecorationStyle: 'dashed',
            textUnderlineOffset: 5,
          }}
        >
          {props.label}
        </Typography>
      </InputLabel>
      {props.control && (
        <Controller
          name={props.name || ''}
          control={props.control}
          rules={props.rules}
          defaultValue={props.value}
          render={({ field: { onChange, value }, fieldState: { error } }) =>
            renderTextField(onChange, value, error)
          }
        />
      )}
      {!props.control &&
        renderTextField(props.onChange, props.value, undefined)}
    </>
  );
};
